<template>
  <div
    class="hover:bg-blue-100 w-full flex font-normal pl-2 pr-2 bg:"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
    @click="$emit('show')"
  >
    <div class="w-1/12 py-2">
      <font-awesome-icon
        v-if="!isSelected"
        :icon="['fal', 'circle']"
        size="lg"
        class="mr-1 text-blue-400 cursor-pointer"
        @click.stop="updateSelection()"
      />
      <font-awesome-icon
        v-else
        :icon="['fas', 'circle']"
        size="lg"
        class="mr-1 text-blue-400 cursor-pointer"
        @click.stop="updateSelection()"
      />
    </div>
    <div
      class="w-3/12 pt-2 text-left"
    >
      {{ customLabel.name }}
    </div>
    <div class="w-2/12 pt-2 text-left">
      {{ customLabel.synonyms.length }}
    </div>
    <div class="w-2/12 pt-2 text-left">
      {{ customLabel.author }}
    </div>
    <div class="w-2/12 pt-2 text-left">
      {{ customLabel.projects.map(p => p.name).join(',') }}
    </div>
    <div class="w-2/12 pt-2 text-right text-gray-500">
      <font-awesome-icon
        :icon="['fal', 'trash-alt']"
        class="cursor-pointer float-right ml-4 mb-4 mt-2 "
        @click.stop="deleteCustomLabel()"
      />
      <vue-blob-json-csv
        file-type="json"
        :file-name="customLabel.name"
        :data="[downloadableData]"
      >
        <font-awesome-icon
          :icon="['fal', 'arrow-to-bottom']"
          size="lg"
          class="float-right ml-4 mb-4 mt-2 cursor-pointer"
        />
      </vue-blob-json-csv>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTrashAlt, faArrowToBottom, faCircle } from '@fortawesome/pro-light-svg-icons'
import { faCircle as CircleSolid } from '@fortawesome/pro-solid-svg-icons'
import { actionNames } from '@/custom-labels/store'
library.add(faTrashAlt, faArrowToBottom, CircleSolid, faCircle)
export default {
  name: 'CustomLabel',
  components: {
    FontAwesomeIcon
  },
  props: {
    customLabel: { type: Object, default: () => ({}) },
    isSelected: { type: Boolean, default: false }
  },
  computed: {
    downloadableData () {
      return {
        name: this.customLabel.name,
        synonyms: this.customLabel.synonyms,
        excludes: this.customLabel.excludes
      }
    }
  },
  methods: {
    async deleteCustomLabel () {
      const accepted = await this.$swal('warning', {
        title: this.$t('Delete Custom Label', 'Delete Custom Label'),
        text: this.$t('Delete Custom Label Text', 'Do you want to delete the custom label?'),
        icon: 'error',
        dangerMode: true,
        buttons: true
      })
      if (!accepted) {
        return
      }
      await this.$store.dispatch(actionNames.DELETE_CUSTOM_LABEL, this.customLabel.id)
    },
    updateSelection () {
      this.$emit('select-clicked', !this.isSelected)
    }
  }
}
</script>
